/*eslint-disable lodash/prefer-lodash-method*/
import once from 'lodash/once';
import { EXPERIMENT_PAGE_TYPE_TEXT, EXPERIMENT_ELEMENT_TYPE_TEXT, TARGET_TYPE_DEVICE_TYPE_MAP, DEVICE_TYPE, STORE } from '../../config/constants';
import { experimentId, alternativeId, projectId, appId, pageType, elementType, targetType, storeId, categories, hook } from '../../vendor/splitmetrics-track';
import { EVENT_NAME as EVENT_ANY_ACTION } from '../track-event/any-action';
import { EVENT_NAME as EVENT_INSTALL } from '../track-event/install';
import { EVENT_NAME as EVENT_APP_VIEW } from '../track-event/app-view';



const GA_EVENT_PAGE_VIEW = 'PageView';
const GA_EVENT_ANY_ACTION = 'Explore';
const GA_EVENT_INSTALL = 'Install';
const GA_EVENT_APP_VIEW = 'Install';

const ga = window.ga;



const track = (action, {
  trackerName,
  experimentId = 'undefined',
  alternativeId = 'undefined',
  projectId = 'undefined',
  appId = 'undefined',
  pageType = 'undefined',
  elementType = 'undefined',
  targetType = 'undefined',
  storeId = 'undefined',
  categories = 'undefined'
}, callback = null) => {

  let handler = () => {};

  if (callback) {
    let timer = null;

    handler = once(() => {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }

      callback();
    });

    timer = setTimeout(handler, 3000);
  }

  const device = TARGET_TYPE_DEVICE_TYPE_MAP[targetType] || DEVICE_TYPE.OTHER;
  const page = EXPERIMENT_PAGE_TYPE_TEXT[pageType] || 'undefined';
  const element = EXPERIMENT_ELEMENT_TYPE_TEXT[elementType] || 'undefined';

  categories = Array.isArray(categories) ? categories : [ categories ];

  if (storeId === STORE.GOOGLE_PLAY) {
    categories = categories.map((el) => String(el).toUpperCase());
  }

  if (!appId) {
    appId = 'prelaunch';
  }

  if (!categories.length) {
    categories = 'undefined';
  } else {
    categories = categories.join();
  }

  const gaOpts = {
    hitType: 'event',
    hitCallback: handler,
    eventCategory: 'SplitMetrics Experiments',
    eventAction: action,
    eventLabel: `${projectId}/${experimentId}/${alternativeId}/${appId}/${storeId}/${categories}/${device}/${page}/${element}`
  };

  ga(`${trackerName}.send`, gaOpts);
};

const getGaOptionsForTracker = (trackerName) => ({
  trackerName,
  experimentId,
  alternativeId,
  projectId,
  appId,
  pageType,
  elementType,
  targetType,
  storeId,
  categories
});

const setupGaHooks = (gaOptions) => {
  track(GA_EVENT_PAGE_VIEW, gaOptions);

  const offEventAnyActionHook = hook(EVENT_ANY_ACTION, {}, once(() => {
    offEventAnyActionHook();
    track(GA_EVENT_ANY_ACTION, gaOptions);
  }));

  const offEventInstallHook = hook(EVENT_INSTALL, {}, once((props, done) => {
    offEventInstallHook();
    track(GA_EVENT_INSTALL, gaOptions, done);
  }));

  const offEventAppViewHook = hook(EVENT_APP_VIEW, {}, once((props, done) => {
    offEventAppViewHook();
    track(GA_EVENT_APP_VIEW, gaOptions, done);
  }));
};

const setupGa4Script = (externalId) => {
  const head = document.getElementsByTagName('head')[0];
  const ga4Script = document.createElement('script');

  ga4Script.async = true;
  ga4Script.src = `https://www.googletagmanager.com/gtag/js?id=${externalId}`;

  const gtagInitScript = document.createElement('script');

  gtagInitScript.text = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${externalId}');`;

  head.prepend(ga4Script, gtagInitScript);
};

const setupGa4Hooks = (externalId) => {
  gtag('js', new Date());
  gtag('config', externalId, {
    page_title: document.title,
    page_path: location.pathname
  });

  gtag('event', GA_EVENT_PAGE_VIEW);

  const offEventAnyActionHook = hook(EVENT_ANY_ACTION, {}, once(() => {
    offEventAnyActionHook();
    gtag('event', GA_EVENT_ANY_ACTION);
  }));

  const offEventInstallHook = hook(EVENT_INSTALL, {}, once(() => {
    offEventInstallHook();
    gtag('event', GA_EVENT_INSTALL);
  }));

  const offEventAppViewHook = hook(EVENT_APP_VIEW, {}, once(() => {
    offEventAppViewHook();
    gtag('event', GA_EVENT_APP_VIEW);
  }));
};

export default ({ data: { tracker_name: trackerName = null } = {} }) => {
  if (!ga || !trackerName) {
    return;
  }

  const gaOptions = getGaOptionsForTracker(trackerName);

  setupGaHooks(gaOptions);
};

export const ga4 = ({ external_id }) => {
  setupGa4Script(external_id);
  setupGa4Hooks(external_id);
};



// WEBPACK FOOTER //
// ./src/lib/tracking-integrations/ga-event.js